import React from 'react';
import { Box } from '@mui/material';

type BackgroundProps = {
  image: string | undefined;
};

const Background: React.FC<BackgroundProps> = ({
  image,
}) => {
  return (
    <Box
      position="absolute"
      width="100%"
      minHeight="100vh"
      sx={(theme) => ({
        inset: 0,
        background: image
          ? `radial-gradient(circle at top, rgba(201, 149, 106, 0.18), transparent 28%),
            linear-gradient(${theme.HEPalette.gradients.dark.main}CC, ${theme.HEPalette.gradients.dark.state}E6),
            url(${image})`
          : `radial-gradient(circle at top, rgba(201, 149, 106, 0.18), transparent 28%),
            linear-gradient(180deg, ${theme.HEPalette.gradients.dark.main}, ${theme.HEPalette.gradients.dark.state})`,
        backgroundSize: image ? 'cover' : '100% 100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      })}
    />
  );
};

export default Background;
